<template>
    <vue-pull-refresh
        :on-refresh="onRefresh"
        :config="pullToFreshConfig"
    >
        <div class="container" v-if="inApp">
            <my-point :point="user.points" v-if="loggedIn"></my-point>

            <div class="row" v-if="loggedIn">
                <div class="col-12 px-0">
                    <div class="nav-container d-flex justify-content-center">
                        <ul class="gift-nav">
                            <li :class="{ 'active': currentTab == 'all'}" @click="changeTab('all')">全部獎賞</li>
                            <li :class="{ 'active': currentTab == 'my'}" @click="changeTab('my')">我的禮品</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row my-3" v-show="currentTab == 'all'">
                <div :class="{ 'col-12': gifts.length <= 1, 'col-6': gifts.length > 1}" class="mb-3" v-for="(gift, index) in gifts" :key="index">
                    <div class="gift-container">
                        <div class="gift-detail">
                            <div class="gift-image text-center d-flex align-items-center" :class="{ 'fixed-height': gifts.length > 1}">
                                <a :href="'/gifts/' + gift.id + '/' + gift.name">
                                    <img :src="gift.image" class="img-fluid">
                                </a>
                            </div>

                            <div class="gift-name text-center">
                                {{ gift.name }}
                            </div>

                            <div class="gift-point text-center" v-if="!gift.expired">
                                {{ gift.points }}分
                            </div>

                            <div class="expired text-danger text-center" v-if="gift.expired">
                                已過期
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row px-2 py-3" :class="{ 'bg-white': index % 2 == 0, 'bg-gray': index % 2 != 0 }" v-for="(code, index) in user.redeemedCodes" :key="code.id" v-show="currentTab == 'my'">
                <div class="col-3 px-0">
                    <div class="d-flex align-items-center gift-image-box border">
                        <img :src="code.gift.image" class="img-fluid">
                    </div>
                </div>
                <div class="col-9 d-flex align-items-center">
                    <div>
                        <p>{{ code.gift.name }} <br> <small>換領日期：{{ code.redeemed_at | date }}</small></p>
                    </div>
                </div>
            </div>

            <div class="button-container text-center disabled" v-if="!loggedIn">
                <a @click="redirectToAppLogin()" class="btn btn-block">登入換領禮品</a>
            </div>
        </div>
    </vue-pull-refresh>
</template>

<script>
import Autentication from './mixins/authentication'
import User from './mixins/user'
import RedirectToLogin from './mixins/redirectToLogin'
import MyPoint from './MyPoint'
import VuePullRefresh from 'vue-pull-refresh';

export default {
    name: 'gift-list',

    mixins: [
        Autentication,
        User,
        RedirectToLogin
    ],

    components: {
        'my-point': MyPoint,
        'vue-pull-refresh': VuePullRefresh
    },

    async mounted() {
        await this.authentication()
        await this.getGifts()

        if (this.loggedIn) {
            await this.getUser()
            this.initTab()
        }
    },

    data() {
        return {
            inApp: false,
            currentTab: 'all',
            gifts: [],
            pullToFreshConfig: {
                'errorLabel': '數據異常',
                'readyLabel': '鬆開立即更新',
                'loadingLabel': '更新中...',
                'startLabel': '向下拉更新數據'
            }
        }
    },

    methods: {
        initTab() {
            const url = new URL(window.location.href)

            if (url.searchParams.has('type')) {
                const type = url.searchParams.get('type')

                this.changeTab(type)
            }
        },

        changeTab(type) {
            this.currentTab = type;
        },

        async getGifts() {
            try {
                const { status, data } = await axios.get('/gifts');

                if (status == 200) {
                    if (data.data.length > 0) {
                        this.gifts = data.data;

                        return
                    }

                    window.location.href = '/no-available-gift';
                }
            } catch (error) {
                console.log(`Failed to get gift list. Error:${error.message}`)
            }
        },

        async onRefresh() {
            return new Promise((resolve, reject) => {
                setTimeout(async () => {
                    await this.getGifts()

                    if (this.loggedIn) {
                        await this.getUser()
                    }

                    resolve();
                }, 500)
            })
        }
    },

    filters: {
        date(value) {
            return moment(value).format('Y-M-D HH:mm:ss')
        }
    }
}
</script>


<style lang="scss" scoped>
.gift-image-box {
    width: 90px;
    height: 90px;
}

.gift-container {
    background: rgb(239,221,143);
    background: linear-gradient(220deg, rgba(239,221,143,1) 0%, rgba(168,108,36,1) 25%, rgba(239,221,143,1) 50%, rgba(168,108,36,1) 75%, rgba(168,108,36,1) 100%);

    border-radius: 5px;
    padding:5px;

    .gift-detail {
        background-color: #FFFFFF;
        padding: 5px;

        .gift-image {
            background-color: #EDEDED;
        }

        .fixed-height {
            height: 120px;
        }

        .gift-name {
            height: 50px;
        }

        .gift-point {
            color: #54aba0;
            font-size: 1.25rem;
            font-weight: bold;
        }

        .expired {
            color: red;
            font-size: 1.25rem;
            font-weight: bold;
        }
    }
}

.nav-container {
    background-color: #ededed;

    ul {
        padding: 0;
        padding-top: 10px;
        padding-bottom: 10px;
        margin: 0;

        &.gift-nav {
            li {
                display:inline;
                margin-right: 20px;

                border-radius: 5px;
                padding: 3px 5px;

                background-color: #FFFFFF;
                color: #C0C0C0;

                a {

                    text-decoration: none;
                }

                font-weight: bold;

                &.active{
                    background-color: #377677;
                    color: #FFFFFF;
                }
            }
        }
    }
}

.pull-down-header {
    background-color: #FFFFFF !important;
}
</style>
